import React, {useState, useEffect} from "react";
import {Container, TextField, Dialog, CircularProgress, Slide, Button} from "@material-ui/core";
import {MuiThemeProvider} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";

import MUIDataTable from "mui-datatables";
import {datatableThemeInTabsPage} from "assets/css/datatable-theme.js";
import axios from "axios";

import Moment from "react-moment";
import OperationDialog from "./Components/OperationDialog.js";
import SnDialog from "./Components/SnDialog.js";

import CustomToolbar from "../../CustomToolbar";
import TabsOnTop from "./Components/TabsOnTop.js";
import FilterComponent from "./Components/FilterComponent.js";
import {getCookie} from "components/auth/Helpers";
import "./FinanceReports.css";
import EditDiscount from "./Components/EditDiscount.js";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FinanceReport = () => {
  const token = getCookie("token");
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState([]); //table items
  const [itemsBackup, setItemsBackup] = useState([]);
  const [clientsList, setClientsList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [neighbourhoodsList, setNeighbourhoodsList] = useState([]);
  const [cabinetsList, setCabinetsList] = useState([]);
  const [fridgesTypesList, setFridgesTypesList] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [filterDialog, setFilterDialog] = useState(false);
  const [pagingInfo, setPagingInfo] = useState({page: 0, limit: 20, skip: 0, count: 20}); //Pagination Info
  const [searchEntry, setSearchEntry] = useState([]); //searchEntry
  const [openOperationDialog, setOpenOperationDialog] = useState(false);
  const [operationNum, setOperationNum] = useState();
  const [supplierName, setSupplierName] = useState("");
  const [suppliersList, setSuppliersList] = useState("");
  const [openSnDialog, setOpenSnDialog] = useState(false);
  const [snId, setSnId] = useState();
  const [tabs, setTabs] = useState({});
  const [record, setRecord] = useState({});
  const [recordId, setRecordId] = useState(0);
  const [formTitle, setFormTitle] = useState("");
  const [openEditDiscount, setOpenEditDiscount] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      await axios
        .all([
          axios.get(`${process.env.REACT_APP_BASE_URL}/cabinets`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/clients`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/cities`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/neighbourhoods`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/fridgesTypes`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/suppliers`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
        ])
        .then((response) => {
          setCabinetsList(response[0].data.data);
          setClientsList(response[1].data);
          setCitiesList(response[2].data);
          setNeighbourhoodsList(response[3].data);
          setFridgesTypesList(response[4].data);
          setSuppliersList(response[5].data);
        });
    };
    fetchData();
  }, []);

  const fetchTabsData = async (formValues = null) => {
    let filterArray = [];

    if (formValues) {
      if (formValues.client._id) filterArray.push(`clientId=${formValues.client._id}`);
      if (formValues.fridgesType._id) filterArray.push(`fridgeTypeId=${formValues.fridgesType._id}`);
      if (formValues.operationType.name) filterArray.push(`operationType=${formValues.operationType.name}`);
      if (formValues.status) filterArray.push(`status=${formValues.status}`);
      if (formValues.fromDate) filterArray.push(`fromDate=${formValues.fromDate}`);
      if (formValues.toDate) filterArray.push(`toDate=${formValues.toDate}`);
      if (searchEntry) filterArray.push(`searchEntry=${searchEntry}`);
    }

    await axios(`${process.env.REACT_APP_BASE_URL}/financial/tabs?get='all'&${filterArray.join("&")}`, {
      responseType: "json",
      headers: {Authorization: `Bearer ${token}`},
    })
      .then((response) => {
        setTabs(response.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    // await axios(
    //   `${process.env.REACT_APP_BASE_URL}/financial?limit=${pagingInfo.limit}&skip=${pagingInfo.skip}&searchEntry=${searchEntry}`,
    //   {
    //     responseType: "json",
    //     headers: {Authorization: `Bearer ${token}`},
    //   }
    // )

    await axios(
      `${process.env.REACT_APP_BASE_URL}/financial?limit=${pagingInfo.limit}&skip=${
        pagingInfo.skip
      }&${filterArray.join("&")}`,
      {responseType: "json", headers: {Authorization: `Bearer ${token}`}}
    )
      .then((response) => {
        setPagingInfo({...pagingInfo, count: response.data.count});
        setItems(response.data.data);
        setItemsBackup(response.data.data);
        return setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    fetchTabsData();
  }, [pagingInfo.page, pagingInfo.limit, searchEntry, openEditDiscount]);

  const [columns, setColumns] = useState([]);
  useEffect(() => {
    setColumns([
      {
        name: "_id",
        options: {
          display: false,
        },
      },
      {
        name: "createdAt",
        label: "Day",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => <Moment format="DD MMM YYYY">{value}</Moment>,
        },
      },
      {
        name: "location",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            if (value) {
              let cityValue = "-";
              let neighbourhoodValue = "-";

              if (citiesList.filter((e) => e._id == value.city_id)[0]) {
                cityValue = citiesList.filter((e) => e._id == value.city_id)[0]?.name;
              }
              if (neighbourhoodsList.filter((e) => e._id == value.neighbourhood_id)[0]) {
                neighbourhoodValue = neighbourhoodsList.filter((e) => e._id == value.neighbourhood_id)[0]
                  ?.name;
              }
              return (
                <div style={{width: 230, display: "flex", alignItems: "center"}}>
                  <div className="avatar_circle">{cityValue.substring(0, 2)}</div>
                  <div>
                    {cityValue}
                    <br />
                    {neighbourhoodValue}
                    <br />
                    <strong>
                      {value ? value.shop_name : "-"} / {value ? value.mobile : "-"}
                    </strong>
                  </div>
                </div>
              );
            }
          },
        },
      },
      {
        name: "operation_number",
        label: "Operation #",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            let supplierName = "";
            if (tableMeta.rowData[10]) {
              let supplierValue = suppliersList.length
                ? suppliersList.find((e) => e._id == tableMeta.rowData[10])
                : [];
              supplierName = supplierValue ? supplierValue.name : "";
            }
            return (
              <div>
                <a onClick={() => handleOpenOperationDialog(value, supplierName)}>{value}</a>
              </div>
            );
          },
        },
      },
      {
        name: "live_operation_type",
        label: "Operation Type",
      },

      {
        name: "status",
        label: "Status",
      },
      {
        name: "replacement",
        label: "Replacement",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            return value ? "YES" : "NO";
          },
        },
      },
      {
        label: "Fridge",
        name: "sn",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            if (value) {
              let snValue = cabinetsList.filter((e) => e._id == value);
              return (
                <div>
                  <a onClick={() => handleOpenSnDialog(value)}>{snValue.length ? snValue[0].sn : "-"}</a>
                </div>
              );
            }
          },
        },
      },
      {
        label: "Client",
        name: "sn",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            let client = "";

            if (cabinetsList.filter((e) => e._id === value).length) {
              let clientId = cabinetsList.filter((e) => e._id === value)[0].client;
              client = clientsList.filter((e) => e._id === clientId).length
                ? clientsList.filter((e) => e._id === clientId)[0]?.name
                : "";
            }
            return client;
          },
        },
      },
      {
        label: "Fridge Type",
        name: "sn",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            let type = "";
            if (cabinetsList.filter((e) => e._id === value).length) {
              let typeId = cabinetsList.filter((e) => e._id === value)[0].type;
              type = fridgesTypesList.filter((e) => e._id === typeId).length
                ? fridgesTypesList.filter((e) => e._id === typeId)[0]?.name
                : "";
            }
            return type;
          },
        },
      },
      {label: "Handling IN/OUT", name: "handling_in"},
      // {label: "Storage", name: "storage"},
      {label: "In House Prev", name: "in_house_preventive_maintenance"},
      {label: "In House Corrective", name: "corrective_service_in_house"},
      {label: "Testing", name: "cabinet_testing_fees"},
      {label: "Branding", name: "branding_fees"},
      {label: "Transportation", name: "transportation_fees"},
      {label: "Installation", name: "installation"},
      {label: "Drop", name: "drop"},
      {label: "Preventive", name: "preventive_maintenance"},
      {label: "Exchange Corrective", name: "exchange_corrective_reaction"},
      {label: "Corrective", name: "corrective_reaction"},
      {
        label: "Discount",
        name: "discount",

        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <a
                  onClick={() => handleEditDiscount("Edit Discount", tableMeta.rowData[0], tableMeta.rowData)}
                >
                  {value ? value : 0}
                </a>
              </div>
            );
          },
        },
      },

      {label: "Total", name: "total"},
    ]);
  }, [citiesList, neighbourhoodsList, suppliersList, cabinetsList]);

  let tableOptions = [
    {name: "day", label: "Day", download: true},
    {name: "city", label: "City", download: true},
    {name: "neighbourhood", label: "Neighbourhood", download: true},
    {name: "location", label: "Location", download: true},
    {name: "mobile", label: "mobile", download: true},
    {name: "operation_number", label: "Operation", download: true},
    {name: "operation_type", label: "Operation Type", download: true},
    {name: "status", label: "Status", download: true},
    {name: "replacement", label: "Replacement", download: true},
    {name: "fridge", label: "Fridge", download: true},
    {name: "fridge_type", label: "Fridge Type", download: true},
    {label: "Handling IN/OUT", name: "handling_in", download: true},
    {label: "Storage", name: "storage", download: true},
    {label: "In House Prev", name: "in_house_preventive_maintenance", download: true},
    {label: "In House Corrective", name: "corrective_service_in_house", download: true},
    {label: "Testing", name: "cabinet_testing_fees", download: true},
    {label: "Branding", name: "branding_fees", download: true},
    {label: "Transportation", name: "transportation_fees", download: true},
    {label: "Installation", name: "installation", download: true},
    {label: "Drop", name: "drop", download: true},
    {label: "Preventive", name: "preventive_maintenance", download: true},
    {label: "Exchange Corrective", name: "exchange_corrective_reaction", download: true},
    {label: "Corrective", name: "corrective_reaction", download: true},
    {label: "Total", name: "total", download: true},
  ];

  const handleCustomDownload = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/financials/export`, {
        headers: {Authorization: `Bearer ${token}`},
      });

      const fields = tableOptions.map((opt) => opt.name);
      const headers = tableOptions.map((opt) => `"${opt.label}"`).join(",");

      const rows = response.data.data.map((item) =>
        fields
          .map((field) => {
            const value = item[field] ?? "";
            // Escape quotes by doubling them
            return `"${String(value).replace(/"/g, '""')}"`;
          })
          .join(",")
      );

      const csvContent = [headers, ...rows].join("\n");

      // Create and trigger a download
      const blob = new Blob([csvContent], {type: "text/csv;charset=utf-8;"});
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "financials.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("CSV download failed:", error);
    }
  };

  const options = {
    filter: false,
    download: false,
    onRowsDelete: null,
    rowsPerPage: pagingInfo.limit,
    rowsPerPageOptions: [20, 50, 100],
    selectToolbarPlacement: "replace",
    customToolbar: () => {
      return (
        <CustomToolbar
          handleFilter={handleFilter}
          additional={
            <Button onClick={handleCustomDownload} variant="contained" color="primary">
              Export CSV
            </Button>
          }
        />
      );
    },

    // onDownload: (buildHead, buildBody, columns, data) => {
    //   let tableOptions = [
    //     {name: "day", label: "Day", download: true},
    //     {name: "city", label: "City", download: true},
    //     {name: "neighbourhood", label: "Neighbourhood", download: true},
    //     {name: "location", label: "Location", download: true},
    //     {name: "mobile", label: "mobile", download: true},
    //     {name: "operation_number", label: "Operation", download: true},
    //     {name: "operation_type", label: "Operation Type", download: true},
    //     {name: "status", label: "Status", download: true},
    //     {name: "fridge", label: "Fridge", download: true},
    //     {name: "fridge_type", label: "Fridge Type", download: true},
    //     {label: "Handling IN/OUT", name: "handling_in", download: true},
    //     {label: "Storage", name: "storage", download: true},
    //     {label: "In House Prev", name: "in_house_preventive_maintenance", download: true},
    //     {label: "In House Corrective", name: "corrective_service_in_house", download: true},
    //     {label: "Testing", name: "cabinet_testing_fees", download: true},
    //     {label: "Branding", name: "branding_fees", download: true},
    //     {label: "Transportation", name: "transportation_fees", download: true},
    //     {label: "Installation", name: "installation", download: true},
    //     {label: "Drop", name: "drop", download: true},
    //     {label: "Preventive", name: "preventive_maintenance", download: true},
    //     {label: "Exchange Corrective", name: "exchange_corrective_reaction", download: true},
    //     {label: "Corrective", name: "corrective_reaction", download: true},
    //     {label: "Total", name: "total", download: true},
    //   ];

    //   axios
    //     .get(`${process.env.REACT_APP_BASE_URL}/financials/export`, {
    //       headers: {Authorization: `Bearer ${token}`},
    //     })
    //     .then((response) => {
    //       console.log(response.data);

    //       const fields = tableOptions.map((opt) => opt.name);

    //       const tableData = response.data.map((item, index) => ({
    //         index,
    //         data: fields.map((field) => item[field] ?? ""), // maintain field order
    //       }));

    //       return buildHead(tableOptions) + buildBody(tableData);
    //     });
    // },

    serverSide: true,
    count: pagingInfo.count, // Use total number of items
    page: pagingInfo.page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setPagingInfo({...pagingInfo, page: tableState.page, skip: tableState.page * pagingInfo.limit});
      } else if (action === "changeRowsPerPage") {
        setPagingInfo({...pagingInfo, limit: tableState.rowsPerPage});
      }
    },
  };

  const handleEditDiscount = (title, id, rec) => {
    setRecord(rec);
    setOpenEditDiscount(true);
    setRecordId(id);
    setFormTitle(title);
  };
  const handleCloseEditDiscount = () => setOpenEditDiscount(false);
  const handleFilter = () => {
    setFilterDialog(true);
  };

  const handleOpenOperationDialog = (operationNum, supplierName) => {
    setOpenOperationDialog(true);
    setOperationNum(operationNum);
    setSupplierName(supplierName);
  };

  const handleOpenSnDialog = (id) => {
    setOpenSnDialog(true);
    setSnId(id);
  };
  //Search component ---------------START--------------

  //Search component ---------------START--------------
  const handleChangeSearch = (e, newValue) => {
    setSearchEntry(newValue);
  };
  //Search component ---------------END--------------
  return (
    <>
      <TabsOnTop
        pagingInfo={pagingInfo}
        searchEntry={searchEntry}
        tabIndex={tabIndex}
        setTabIndex={setTabIndex}
        tabs={tabs}
        setItems={setItems}
        setItemsBackup={setItemsBackup}
        setIsLoading={setIsLoading}
        setColumns={setColumns}
      />
      <Container maxWidth="xl" style={{paddingTop: "4rem"}}>
        <Autocomplete
          multiple
          freeSolo
          limitTags={3}
          id="tags-standard"
          options={[]}
          getOptionLabel={(option) => option}
          onChange={handleChangeSearch}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder="Search Data"
              label="Filter by Job #, Operation # and Serial #"
            />
          )}
        />
        {!isLoading ? (
          <MuiThemeProvider theme={datatableThemeInTabsPage}>
            <MUIDataTable title="" data={items} columns={columns} options={options} />
          </MuiThemeProvider>
        ) : (
          <CircularProgress size={30} className="pageLoader" />
        )}
      </Container>

      {/*********************** -Operation Dialog START- ****************************/}
      <Dialog
        maxWidth={"xl"}
        fullWidth
        TransitionComponent={Transition}
        open={openOperationDialog}
        onClose={() => setOpenOperationDialog(false)}
      >
        <OperationDialog
          setOpenDialog={setOpenOperationDialog}
          operationNum={operationNum}
          supplierName={supplierName}
          cabinetsList={cabinetsList}
        />
      </Dialog>

      {/*********************** -Sn Dialog START- ****************************/}
      <Dialog
        maxWidth={"xl"}
        fullWidth
        TransitionComponent={Transition}
        open={openSnDialog}
        onClose={() => setOpenSnDialog(false)}
      >
        <SnDialog setOpenDialog={setOpenSnDialog} snId={snId} cabinetsList={cabinetsList} />
      </Dialog>
      {/*********************** FILTER start ****************************/}
      <Dialog
        onClose={() => setFilterDialog(false)}
        maxWidth={"xl"}
        fullWidth
        aria-labelledby="customized-dialog-title"
        open={filterDialog}
      >
        <FilterComponent
          pagingInfo={pagingInfo}
          searchEntry={searchEntry}
          setOpenDialog={setFilterDialog}
          setItems={setItems}
          setPagingInfo={setPagingInfo}
          fetchTabsData={fetchTabsData}
        />
      </Dialog>

      <Dialog
        fullScreen
        open={openEditDiscount}
        onClose={handleCloseEditDiscount}
        TransitionComponent={Transition}
      >
        <EditDiscount
          title={formTitle}
          handleClose={handleCloseEditDiscount}
          recordId={recordId}
          record={record}
        />
      </Dialog>
    </>
  );
};
export default FinanceReport;
